const n = "{{currentTime}} van de {{duration}}", e = "Zoekresultaat {{current}} van de {{total}}", t = "Geen resultaten gevonden", o = "{{count}} resultaat gevonden", s = "{{count}} resultaten gevonden", c = 'Afspelen vanuit $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) en $t(SECONDS, { "count": {{seconds}} }).', A = 'Afspelen vanuit $t(MINUTES, { "count": {{minutes}} }) en $t(SECONDS, { "count": {{seconds}} }).', T = 'Afspelen vanuit $t(SECONDS, { "count": {{seconds}} }).', i = "Fout bij het opslaan van de wijzigingen aan het transcript.", E = "Transcriptregel op {{time}}. Inhoud is: {{text}}.", r = 'Container voor transcriptregels. Er $t(TRANSCRIPT_LINES, { "count": {{count}} }) binnen deze container. Gebruik de pijl-omlaag om binnen deze container te navigeren.', _ = "Wijzigingen opslaan...", S = "Wijzigingen opgeslagen in transcript.", a = "Er is nu een knop voor het bijwerken van ondertitels beschikbaar.", l = "Actie", N = "Aantekening toevoegen om {{time}}", O = "Vraag toevoegen om {{time}}", R = "Aantekeningen", I = "Automatisch", u = "Automatisch ({{quality}})", C = "Terug", P = "Ondertiteling", g = "Taal ondertiteling", U = "Ondertiteling beheren", d = "{{language}} verwijderen", p = "Lettergrootte", L = "Taal ondertiteling: {{language}}", D = "{{language}} (automatisch)", m = "Zoekopdracht wissen", M = "Sluiten", h = "Opmerkingen", G = "Doorgaan", k = "Afspeelsnelheid verlagen", V = "Volume verlaagd met {{percent}}%", Y = "Pijl-omlaag", v = "Transcriptbewerker sluiten", b = "Ondertiteling bijwerken", H = "Fout!", f = "Bezig met opslaan...", B = "Opgeslagen!", j = "Transcript bewerken", z = "Tekst kan niet leeg zijn!", K = "Volledig scherm", w = "{{count}} uur", W = "{{count}} uur", F = "Afspeelsnelheid verhogen", $ = "Volume verhoogd met {{percent}}%", Q = "Kleuren omkeren", Z = "Ga direct naar een specifiek percentage (1-10%, 2-20%, enz.)", J = "Ga direct naar start", x = "Acties voor {{title}}", X = "Sneltoetsen", q = "Taal", y = "Pijl-links", nn = "Hoofdmenu", en = "{{count}} minuut", tn = "{{count}} minuten", on = "Verbergen", sn = "Verborgen", cn = "Taal volgende ondertiteling", An = "Volgende zoekresultaat", Tn = "Uit", En = "Bovenaan", rn = "Aantekening openen om {{time}}", _n = "Voltooide toets openen om {{time}}", Sn = "Toets openen om {{time}}", an = "Onderbreken", ln = "Afspelen", Nn = "Afspeelsnelheid", On = "Afspeelsnelheid: {{speed}}x", Rn = "Taal vorige ondertiteling", In = "Vorige zoekresultaat", un = "Kwaliteit", Cn = "Kwaliteitsmenu", Pn = "Opnieuw afspelen", gn = "Afspeelsnelheid opnieuw instellen", Un = "Pijl-rechts", dn = "Zoeken in transcript", pn = "{{count}} seconde", Ln = "{{count}} seconden", Dn = "Achteruit zoeken: {{seconds}} seconden", mn = "Vooruit zoeken: {{seconds}} seconden", Mn = "Instellingen", hn = "Snelkoppeling", Gn = "Mediadetails en -tools", kn = "Spatie", Vn = "Menu afspeelsnelheid", Yn = "Automatisch scrollen starten", vn = "Ondertiteling in-/uitschakelen", bn = "Wisselknop verborgen", Hn = "Wisselknop Afspelen/Pauzeren", fn = "is {{count}} transcriptregel", Bn = "zijn {{count}} transcriptregel", jn = "Transcript wordt geladen...", zn = "We konden het transcript niet laden.", Kn = "Transcriptopties", wn = "Opnieuw proberen", Wn = "Transcript niet beschikbaar", Fn = "Pijl-omhoog", $n = "Video-instellingen", Qn = "Volume", Zn = "Volume: {{volume}}%", Jn = {
  A11Y_DURATION: n,
  A11Y_SEARCH_HITS: e,
  A11Y_SEARCH_NO_RESULTS: t,
  A11Y_SEARCH_RESULTS_FOUND: o,
  A11Y_SEARCH_RESULTS_FOUND_other: s,
  A11Y_TIMESTAMP_JUMP_HOURS: c,
  A11Y_TIMESTAMP_JUMP_MINUTES: A,
  A11Y_TIMESTAMP_JUMP_SECONDS: T,
  A11Y_TRANSCRIPT_ERROR: i,
  A11Y_TRANSCRIPT_LINE: E,
  A11Y_TRANSCRIPT_LINES: r,
  A11Y_TRANSCRIPT_SAVING: _,
  A11Y_TRANSCRIPT_SUCCESS: S,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: a,
  ACTION: l,
  ADD_ANNOTATION_AT: N,
  ADD_QUESTION_AT: O,
  ANNOTATIONS: R,
  AUTO: I,
  AUTO_QUALITY: u,
  BACK: C,
  CAPTIONS: P,
  CAPTIONS_LANGUAGE: g,
  CAPTIONS_MANAGE: U,
  CAPTION_DELETE: d,
  CAPTION_FONT_SIZE: p,
  CAPTION_LANGUAGE: L,
  CAPTION_LANGUAGE_AUTOMATIC: D,
  CLEAR_SEARCH: m,
  CLOSE: M,
  COMMENTS: h,
  CONTINUE: G,
  DECREASE_PLAYBACK_SPEED: k,
  DECREASE_VOLUME: V,
  DOWN_ARROW: Y,
  EDIT_CLOSE: v,
  EDIT_CONFIRM: b,
  EDIT_ERROR: H,
  EDIT_SAVING: f,
  EDIT_SUCCESS: B,
  EDIT_TRANSCRIPT: j,
  EDIT_VALIDATION_ERROR: z,
  FULLSCREEN: K,
  HOURS: w,
  HOURS_other: W,
  INCREASE_PLAYBACK_SPEED: F,
  INCREASE_VOLUME: $,
  INVERT_COLORS: Q,
  JUMP_TO_PERCENTAGE: Z,
  JUMP_TO_START: J,
  KEBAB_MENU: x,
  KEYBOARD_SHORTCUTS: X,
  LANGUAGE: q,
  LEFT_ARROW: y,
  MAIN_MENU: nn,
  MINUTES: en,
  MINUTES_other: tn,
  MUTE: on,
  MUTED: sn,
  NEXT_CAPTION_LANGUAGE: cn,
  NEXT_HIT: An,
  OFF: Tn,
  ON_TOP: En,
  OPEN_ANNOTATION_AT: rn,
  OPEN_COMPLETED_QUIZ_AT: _n,
  OPEN_QUIZ_AT: Sn,
  PAUSE: an,
  PLAY: ln,
  PLAYBACK_SPEED: Nn,
  PLAYBACK_SPEED_MESSAGE: On,
  PREVIOUS_CAPTION_LANGUAGE: Rn,
  PREVIOUS_HIT: In,
  QUALITY: un,
  QUALITY_MENU: Cn,
  REPLAY: Pn,
  RESET_PLAYBACK_SPEED: gn,
  RIGHT_ARROW: Un,
  SEARCH_TRANSCRIPT_PLACEHOLDER: dn,
  SECONDS: pn,
  SECONDS_other: Ln,
  SEEK_BACKWARD: Dn,
  SEEK_FORWARD: mn,
  SETTINGS: Mn,
  SHORTCUT: hn,
  SIDEBAR: Gn,
  SPACE: kn,
  SPEED_MENU: Vn,
  START_AUTOSCROLL: Yn,
  TOGGLE_CAPTIONS: vn,
  TOGGLE_MUTED: bn,
  TOGGLE_PLAY_PAUSE: Hn,
  TRANSCRIPT_LINES: fn,
  TRANSCRIPT_LINES_other: Bn,
  TRANSCRIPT_LOADING: jn,
  TRANSCRIPT_LOAD_ERROR: zn,
  TRANSCRIPT_OPTIONS: Kn,
  TRANSCRIPT_RETRY: wn,
  TRANSCRIPT_UNAVAILABLE: Wn,
  UP_ARROW: Fn,
  VIDEO_SETTINGS: $n,
  VOLUME: Qn,
  VOLUME_VALUE: Zn
};
export {
  n as A11Y_DURATION,
  e as A11Y_SEARCH_HITS,
  t as A11Y_SEARCH_NO_RESULTS,
  o as A11Y_SEARCH_RESULTS_FOUND,
  s as A11Y_SEARCH_RESULTS_FOUND_other,
  c as A11Y_TIMESTAMP_JUMP_HOURS,
  A as A11Y_TIMESTAMP_JUMP_MINUTES,
  T as A11Y_TIMESTAMP_JUMP_SECONDS,
  i as A11Y_TRANSCRIPT_ERROR,
  E as A11Y_TRANSCRIPT_LINE,
  r as A11Y_TRANSCRIPT_LINES,
  _ as A11Y_TRANSCRIPT_SAVING,
  S as A11Y_TRANSCRIPT_SUCCESS,
  a as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  l as ACTION,
  N as ADD_ANNOTATION_AT,
  O as ADD_QUESTION_AT,
  R as ANNOTATIONS,
  I as AUTO,
  u as AUTO_QUALITY,
  C as BACK,
  P as CAPTIONS,
  g as CAPTIONS_LANGUAGE,
  U as CAPTIONS_MANAGE,
  d as CAPTION_DELETE,
  p as CAPTION_FONT_SIZE,
  L as CAPTION_LANGUAGE,
  D as CAPTION_LANGUAGE_AUTOMATIC,
  m as CLEAR_SEARCH,
  M as CLOSE,
  h as COMMENTS,
  G as CONTINUE,
  k as DECREASE_PLAYBACK_SPEED,
  V as DECREASE_VOLUME,
  Y as DOWN_ARROW,
  v as EDIT_CLOSE,
  b as EDIT_CONFIRM,
  H as EDIT_ERROR,
  f as EDIT_SAVING,
  B as EDIT_SUCCESS,
  j as EDIT_TRANSCRIPT,
  z as EDIT_VALIDATION_ERROR,
  K as FULLSCREEN,
  w as HOURS,
  W as HOURS_other,
  F as INCREASE_PLAYBACK_SPEED,
  $ as INCREASE_VOLUME,
  Q as INVERT_COLORS,
  Z as JUMP_TO_PERCENTAGE,
  J as JUMP_TO_START,
  x as KEBAB_MENU,
  X as KEYBOARD_SHORTCUTS,
  q as LANGUAGE,
  y as LEFT_ARROW,
  nn as MAIN_MENU,
  en as MINUTES,
  tn as MINUTES_other,
  on as MUTE,
  sn as MUTED,
  cn as NEXT_CAPTION_LANGUAGE,
  An as NEXT_HIT,
  Tn as OFF,
  En as ON_TOP,
  rn as OPEN_ANNOTATION_AT,
  _n as OPEN_COMPLETED_QUIZ_AT,
  Sn as OPEN_QUIZ_AT,
  an as PAUSE,
  ln as PLAY,
  Nn as PLAYBACK_SPEED,
  On as PLAYBACK_SPEED_MESSAGE,
  Rn as PREVIOUS_CAPTION_LANGUAGE,
  In as PREVIOUS_HIT,
  un as QUALITY,
  Cn as QUALITY_MENU,
  Pn as REPLAY,
  gn as RESET_PLAYBACK_SPEED,
  Un as RIGHT_ARROW,
  dn as SEARCH_TRANSCRIPT_PLACEHOLDER,
  pn as SECONDS,
  Ln as SECONDS_other,
  Dn as SEEK_BACKWARD,
  mn as SEEK_FORWARD,
  Mn as SETTINGS,
  hn as SHORTCUT,
  Gn as SIDEBAR,
  kn as SPACE,
  Vn as SPEED_MENU,
  Yn as START_AUTOSCROLL,
  vn as TOGGLE_CAPTIONS,
  bn as TOGGLE_MUTED,
  Hn as TOGGLE_PLAY_PAUSE,
  fn as TRANSCRIPT_LINES,
  Bn as TRANSCRIPT_LINES_other,
  jn as TRANSCRIPT_LOADING,
  zn as TRANSCRIPT_LOAD_ERROR,
  Kn as TRANSCRIPT_OPTIONS,
  wn as TRANSCRIPT_RETRY,
  Wn as TRANSCRIPT_UNAVAILABLE,
  Fn as UP_ARROW,
  $n as VIDEO_SETTINGS,
  Qn as VOLUME,
  Zn as VOLUME_VALUE,
  Jn as default
};
